import React, { useEffect, useState } from 'react';
import { boardAPI } from '../../../api';

const AdminSuggestions: React.FC = () => {
  const [suggestions, setSuggestions] = useState<any[]>([]);
  const [selected, setSelected] = useState<any>(null);
  const [reply, setReply] = useState('');
  const [status, setStatus] = useState('pending');
  const [page, setPage] = useState(1);
  const PER_PAGE = 20;

  useEffect(() => {
    boardAPI.suggestions().then(res => setSuggestions(res.data));
  }, []);

  const totalPages = Math.ceil(suggestions.length / PER_PAGE);
  const paged = suggestions.slice((page-1)*PER_PAGE, page*PER_PAGE);

  const openDetail = (s: any) => {
    setSelected(s);
    setReply(s.reply || '');
    setStatus(s.status);
  };

  const saveReply = async () => {
    if (!selected) return;
    try {
      await boardAPI.replySuggestion(selected.id, { reply, status });
      alert('저장되었습니다.');
      setSelected(null);
      const res = await boardAPI.suggestions();
      setSuggestions(res.data);
    } catch (e) { alert('저장 실패'); }
  };

  const pendingCount = suggestions.filter(s => s.status === 'pending').length;

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <div className="admin-page-title">
          <span className="icon">📨</span>
          건의사항
          {pendingCount > 0 && (
            <span className="badge badge-danger" style={{ fontSize: 12 }}>미확인 {pendingCount}</span>
          )}
        </div>
        <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>전체 {suggestions.length}건</span>
      </div>

      <div className="card">
        <div className="card-body" style={{ padding: 0 }}>
          <div className="table-wrap">
            <table className="table">
              <thead>
                <tr>
                  <th style={{ width: 40 }}>No</th>
                  <th>제목</th>
                  <th>작성자</th>
                  <th>작성일</th>
                  <th>상태</th>
                </tr>
              </thead>
              <tbody>
                {paged.map((s: any, i: number) => (
                  <tr key={s.id} style={{ cursor: 'pointer' }} onClick={() => openDetail(s)}>
                    <td style={{ textAlign: 'center', color: 'var(--text-muted)' }}>
                      {(page-1)*PER_PAGE + i + 1}
                    </td>
                    <td style={{ fontWeight: 500 }}>{s.title}</td>
                    <td style={{ color: 'var(--text-muted)' }}>{s.author_name}</td>
                    <td style={{ color: 'var(--text-muted)', fontSize: 12 }}>{s.created_at?.slice(0,10)}</td>
                    <td>
                      <span className={`badge ${s.status === 'done' ? 'badge-success' : s.status === 'checked' ? 'badge-info' : 'badge-danger'}`}>
                        {s.status === 'done' ? '처리완료' : s.status === 'checked' ? '확인' : '미확인'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {totalPages > 1 && (
            <div className="pagination">
              <button className="page-btn" onClick={() => setPage(p => Math.max(1, p-1))}>◀</button>
              {Array.from({length: totalPages}, (_, i) => i+1).map(p => (
                <button key={p} className={`page-btn ${p===page?'active':''}`} onClick={() => setPage(p)}>{p}</button>
              ))}
              <button className="page-btn" onClick={() => setPage(p => Math.min(totalPages, p+1))}>▶</button>
            </div>
          )}
        </div>
      </div>

      {/* 상세 모달 */}
      {selected && (
        <div className="modal-overlay" onClick={() => setSelected(null)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-title">📨 건의사항 상세</div>
              <button className="modal-close" onClick={() => setSelected(null)}>✕</button>
            </div>
            <div className="modal-body">
              <div style={{ marginBottom: 12 }}>
                <strong>{selected.title}</strong>
                <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 4 }}>
                  {selected.author_name} · {selected.created_at?.slice(0,10)}
                </div>
              </div>
              <div style={{ background: 'var(--gray-50)', padding: 14, borderRadius: 8, marginBottom: 14, fontSize: 14, lineHeight: 1.7, whiteSpace: 'pre-wrap' }}>
                {selected.content}
              </div>
              <div className="form-group">
                <label className="form-label">상태</label>
                <select className="form-select" value={status} onChange={e => setStatus(e.target.value)}>
                  <option value="pending">미확인</option>
                  <option value="checked">확인</option>
                  <option value="done">처리완료</option>
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">관리자 답변</label>
                <textarea className="form-control" rows={4} value={reply} onChange={e => setReply(e.target.value)} placeholder="답변을 입력하세요..." style={{ resize: 'vertical' }} />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-ghost" onClick={() => setSelected(null)}>닫기</button>
              <button className="btn btn-primary" onClick={saveReply}>💾 저장</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminSuggestions;
